import { PurchaseRequestStatus } from '../../enums';

/**
 * Status em que o PDF do mapa de cotação pode ser baixado: depois da aprovação do mapa.
 * Fora deles o botão não aparece, mesmo com URL (ex.: uma solicitação que voltou para cotação).
 */
export const QUOTATION_MAP_PDF_STATUSES: readonly PurchaseRequestStatus[] = [
  PurchaseRequestStatus.PENDING_INTEGRATION,
  PurchaseRequestStatus.AWAITING_FOR_APPROVAL,
  PurchaseRequestStatus.QUOTED
];

/** O botão do PDF só aparece com URL E num dos status de {@link QUOTATION_MAP_PDF_STATUSES}. */
export function canOpenQuotationMapPdf(
  url: string | null | undefined,
  status: PurchaseRequestStatus | readonly PurchaseRequestStatus[] | null | undefined
): boolean {
  if (!url || !status) return false;
  const statuses = Array.isArray(status) ? status : [status];
  return statuses.some(current => QUOTATION_MAP_PDF_STATUSES.includes(current));
}
